/*
 * @FilePath: /src/main.js
 * @Description:
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import '@/styles/index.css' // global css

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})
;(function () {
  try {
    var u = window.navigator.userAgent
    // eslint-disable-next-line
    var m = u.match(/(kadaiApp)\/([\d\.]+)/)
    if (m && m[2] >= '2.5.0') {
      var url = location.href
      var params = encodeURIComponent('{"url":"' + url + '","callback":""}')
      var api =
        'jsbridge://www.xiaoying.com/app/h5DidFinishLoad?params=' + params
      var iframe = document.createElement('iframe')
      iframe.src = api
      iframe.setAttribute(
        'style',
        'position:absolute;z-index:-1;left:0;bottom:0;width:0;height:0;opacity:0;border:none;'
      )
      iframe.frameborder = 0
      var body = document.getElementsByTagName('body')[0]
      body.appendChild(iframe)
    }
  } catch (err) {
    throw err
  }
})()



// WEBPACK FOOTER //
// ./src/main.js